import React from 'react';
import { Modal } from 'react-bootstrap';

const statusBadgeClass = (status) => {
  const value = status?.toLowerCase();
  if (value === 'active')    return 'badge-success';
  if (value === 'pending')   return 'badge-warning';
  if (value === 'inactive')  return 'badge-danger';
  if (value === 'suspended') return 'badge-light';
  return 'badge-secondary';
};

const InfoRow = ({ label, children }) => (
  <div className="row g-2">
    <div className="col-sm-4 fw-semibold">{label}</div>
    <div className="col-sm-8">{children}</div>
  </div>
);

const YesNoBadge = ({ value }) => (
  value
    ? <span className="badge badge-rounded badge-success">Yes</span>
    : <span className="badge badge-rounded badge-secondary">No</span>
);

const ActiveInactiveBadge = ({ value }) => (
  value
    ? <span className="badge badge-rounded badge-success">Active</span>
    : <span className="badge badge-rounded badge-danger">Inactive</span>
);

const UserInfoModal = ({ show, onHide, currentUser }) => {
  if (!currentUser) return null;

  const reviewedTeamNames = currentUser.reviewed_team_names ?? [];

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center flex-wrap gap-2">
          <span>{currentUser.full_name || 'User details'}</span>
          {currentUser.is_team_reviewer && (
            <span className="badge badge-rounded badge-primary">Team reviewer</span>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-column gap-3">
          <InfoRow label="Preferred name">
            {currentUser.preferred_name || <span className="text-muted">Not set</span>}
          </InfoRow>
          <InfoRow label="Role">{currentUser.role}</InfoRow>
          {currentUser.is_team_reviewer && reviewedTeamNames.length > 0 && (
            <InfoRow label="Reviews">
              {reviewedTeamNames.join(', ')}
            </InfoRow>
          )}
          {currentUser.email && (
            <InfoRow label="Email">
              <span style={{ overflowWrap: 'anywhere' }}>{currentUser.email}</span>
            </InfoRow>
          )}
          {currentUser.phone && (
            <InfoRow label="Phone">{currentUser.phone}</InfoRow>
          )}
          <InfoRow label="Team">
            {currentUser.team || <span className="text-muted">Not assigned</span>}
          </InfoRow>
          {currentUser.status && (
            <InfoRow label="Status">
              <span className={`badge badge-rounded ${statusBadgeClass(currentUser.status)}`}>
                {currentUser.status}
              </span>
            </InfoRow>
          )}
          <InfoRow label="Has wallet">
            <YesNoBadge value={currentUser.has_wallet} />
          </InfoRow>
          {currentUser.has_wallet && (
            <InfoRow label="Wallet">
              <ActiveInactiveBadge value={currentUser.has_active_wallet} />
            </InfoRow>
          )}
          <InfoRow label="Partner vault">
            <ActiveInactiveBadge value={currentUser.has_active_partner_vault} />
          </InfoRow>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default UserInfoModal;
